export enum UserMissionEnum {
  READER = 'READER',
  WRITER = 'WRITER',
}

export enum UserMissionValueEnum {
  READER = 'Reader',
  WRITER = 'Writer',
}
